// extracted by mini-css-extract-plugin
var _1 = "C21ml";
var _2 = "MYHdU";
var _3 = "EWmWb";
var _4 = "p0tQa";
var _5 = "B4GgD elide";
var _6 = "J8zO3 visually-hidden";
var _7 = "d9Jce";
export { _1 as "attr", _2 as "card", _3 as "card-list", _4 as "cards", _5 as "elide", _6 as "hide", _7 as "name" }
